import PropTypes from 'prop-types';
import React from 'react';


const HintWrapper = (props) => {

    let className = "hint-wrapper"

    if (props.alignment) {
        className += " hint-wrapper--" + props.alignment
    }

    if (props.theme) {
        className += " hint-wrapper--" + props.theme
    }

    return (
        <div className={className}>
            <p>{props.children || props.content}</p>
        </div>
    )

}

HintWrapper.propTypes = {
    content: PropTypes.string,
    alignment: PropTypes.string,
    theme: PropTypes.string
}

export default HintWrapper



/** WEBPACK FOOTER **
 ** ./src/components/HintWrapper.js
 **/